<template>
  <main>
     <div id="layout-wrapper">
       <NavBar></NavBar>
        <div class="topnav">
           <div class="container-fluid">
              <nav class="navbar navbar-light navbar-expand-lg topnav-menu">
                 <div class="collapse navbar-collapse" id="topnav-menu-content">
                    <ul class="navbar-nav">
                       <li class="nav-item dropdown">
                          <router-link :to="{name: 'dashboard'}" class="nav-link dropdown-toggle arrow-none" id="topnav-more" role="button" aria-haspopup="true" aria-expanded="false">
                             <i class="bx bxs-home-circle mr-2"></i>Dashboard
                          </router-link>
                       </li>
                       <li class="nav-item dropdown">
                          <router-link :to="{name: 'console'}" class="nav-link dropdown-toggle arrow-none" id="topnav-more" role="button" aria-haspopup="true" aria-expanded="false">
                             <i class="bx bxs-terminal mr-2"></i>Console
                          </router-link>
                       </li>
                       <li class="nav-item dropdown">
                          <router-link :to="{name: 'manager'}" id="topnav-pages" class="nav-link dropdown-toggle arrow-none"  role="button"
                             data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                             <i class="bx bxs-file mr-2"></i>Files
                          </router-link>
                          <div class="dropdown-menu" aria-labelledby="topnav-pages">
                             <router-link :to="{name: 'manager'}" class="dropdown-item">File Manager</router-link>
                             <router-link :to="{name: 'backups'}" class="dropdown-item">Backups</router-link>
                          </div>
                       </li>
                       <li class="nav-item dropdown">
                          <router-link :to="{name: 'browse-plugins'}" class="nav-link dropdown-toggle arrow-none" id="topnav-components" role="button"
                             data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                             <i class="bx bxs-extension mr-2"></i>Plugins
                          </router-link>
                          <div class="dropdown-menu" aria-labelledby="topnav-components">
                             <router-link :to="{name: 'browse-plugins'}" class="dropdown-item">Browse Plugins</router-link>
                             <router-link :to="{name: 'installed-plugins'}" class="dropdown-item">Installed Plugins</router-link>
                          </div>
                       </li>
                       <li class="nav-item dropdown">
                          <router-link :to="{name: 'versions'}" class="nav-link dropdown-toggle arrow-none" href=versions.html id="topnav-more" role="button" aria-haspopup="true" aria-expanded="false">
                             <i class="bx bxs-widget mr-2"></i>Versions
                          </router-link>
                       </li>
                       <li class="nav-item dropdown">
                          <router-link :to="{name: 'settings'}" class="nav-link dropdown-toggle arrow-none" id="topnav-more" role="button" aria-haspopup="true" aria-expanded="false">
                             <i class="bx bxs-cog mr-2"></i>Settings
                          </router-link>
                       </li>
                       <li class="nav-item dropdown">
                          <router-link :to="{name: 'addons'}" class="nav-link dropdown-toggle arrow-none" id="topnav-more" role="button" aria-haspopup="true" aria-expanded="false">
                             <i class="bx bxs-shopping-bag-alt mr-2"></i>Addons
                          </router-link>
                       </li>
                    </ul>
                 </div>
              </nav>
           </div>
        </div>
        <div class="main-content">
           <router-view/>
        </div>
     </div>
     <footer class="footer">
        <div class="container-fluid">
           <div class="row">
              <div class="col-sm-6">
                 Copyright &copy; SpaceMine Ltd 2017 - {{ year }}. All rights reserved.
              </div>
              <div class="col-sm-6">
                 <div class="text-sm-right d-none d-sm-block">
                    Company No. 11084250
                 </div>
              </div>
           </div>
        </div>
     </footer>
  </main>
</template>

<script>
import NavBar from '../elements/NavBar'
import 'bootstrap'
import jQuery from 'jquery'
window.jQuery = jQuery

export default {
  name: 'DashboardView',
  components: {
    NavBar
  },
  data () {
    return {
      year: (new Date().getFullYear())
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/panel/DashboardView.vue